var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 4.16666C19.4649 4.16666 16.6667 6.96488 16.6667 10.4167V89.5833C16.6667 93.0351 19.4649 95.8333 22.9167 95.8333H77.0834C80.5351 95.8333 83.3334 93.0351 83.3334 89.5833V29.1667L58.3334 4.16666H22.9167Z",
    fill: "#4E8DF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 95.8333C19.4649 95.8333 16.6667 93.0351 16.6667 89.5833V88.5417C16.6667 91.9934 19.4649 94.7917 22.9167 94.7917H77.0834C80.5351 94.7917 83.3334 91.9934 83.3334 88.5417V89.5833C83.3334 93.0351 80.5351 95.8333 77.0834 95.8333H22.9167Z",
    fill: "#417EE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 4.16666C19.4649 4.16666 16.6667 6.96488 16.6667 10.4167V11.4583C16.6667 8.00654 19.4649 5.20832 22.9167 5.20832H59.375L58.3334 4.16666H22.9167Z",
    fill: "#639AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3333 50.5208V29.1667L79.6875 25.5208H62.1055C60.7135 25.5208 60.0164 27.2039 61.0007 28.1882L83.3333 50.5208Z",
    fill: "url(#paint0_linear_4_42)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 4.16666L83.3333 29.1667H64.5833C61.1315 29.1667 58.3333 26.3684 58.3333 22.9167V4.16666Z",
    fill: "#A6C5FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 50H33.3333V54.1667H66.6666V50Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 58.3333H33.3333V62.5H66.6666V58.3333Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 66.6667H66.6666V70.8333H33.3333V66.6667Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 75H33.3333V79.1667H58.3333V75Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_42",
    x1: 70.8333,
    y1: 50.5208,
    x2: 70.8333,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D6ACD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.94ffc0b238a02c78b79a1230bc9dceb4.svg";
export { ForwardRef as ReactComponent };